import React, { useEffect, useState } from 'react'
import { Button, Form, Input, Select, Checkbox, DatePicker, TimePicker, Radio } from 'antd'
import moment from 'moment'
import { POST } from '../../utils/apis'
import { clanicData, errorMessage, strToMoment, successMessage } from '../../utils/helpers'
import { useSelector } from 'react-redux'
import axios from 'axios'

const { Option } = Select
const ServiceFormComponent = (props) => {
    const { onCancel, edit, user, language, selectedLanguage, userActions, roles } = props
    const myServices = useSelector(state => state?.userReducer?.clanicServices)
    const myServicesData = myServices?.length ? myServices : []
    const [price, setPrice] = useState(edit?.price || '');
    const [form] = Form.useForm()
    const [repeat, setRepeat] = useState(edit?.repeat ? edit?.repeat : false)
    const [laoding, setLoading] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [repeatType, setRepeatType] = useState(edit?.repeatType ? edit?.repeatType : null);
    const [repeatDates, setRepeatDates] = useState([]);
    const [valuesForCustomDate, setValuesForCustomDate] = useState(edit?.repeatDates || []);
    const [weeklyDay, setWeeklyDay] = useState(edit?.weeklyday || null);
    const dateFormat = 'DD-MM-YYYY'
    console.log('edit', edit)

    useEffect(() => {
        clanicData.getMyAllServices(userActions, user?._id)
    }, [])
    useEffect(() => {
        if (edit?.repeat) {
            form.setFieldsValue({
                repeat: true,
                repeatType: edit?.repeatType,
            })
        }
        if (edit?.repeat && repeatType === 'custom') {
            form.setFieldsValue({
                repeatDates: edit?.repeatDates,
            })
        }
        if (edit?.repeat && repeatType === 'weekly') {
            form.setFieldsValue({
                weeklyday: edit?.weeklyday,
            })
        }
    }, [])

    function getDayOfWeak(dateStr) {
        const dateFormat = 'DD-MM-YYYY';
        const dateObject = moment(dateStr, dateFormat);
        return dateObject.format('dddd');
    }

    const onChangeCustomsDate = (value) => {
        setRepeatDates(value)
    }

    const dailyDateSetup = (startDate, endDate) => {
        const dates = [];
        let currentDate = moment(startDate, dateFormat);
        const lastDate = moment(endDate, dateFormat);
        while (currentDate.isSameOrBefore(lastDate)) {
            dates.push(currentDate.format(dateFormat));
            currentDate.add(1, 'day');
        }
        setRepeatDates(dates)
    };

    const dateSetupForCustom = (startDate, endDate) => {
        const dates = [];
        let currentDate = moment(startDate, dateFormat);
        const lastDate = moment(endDate, dateFormat);
        while (currentDate.isSameOrBefore(lastDate)) {
            dates.push(currentDate.format(dateFormat));
            currentDate.add(1, 'day');
        }
        setValuesForCustomDate(dates)
        form.setFieldsValue({
            repeatDates: dates
        })
    };

    const workingDayDateSetup = (startDate, endDate) => {
        const dates = [];
        let currentDate = moment(startDate, dateFormat);
        const lastDate = moment(endDate, dateFormat);
        while (currentDate.isSameOrBefore(lastDate)) {
            if (currentDate.day() !== 0 && currentDate.day() !== 6) {
                dates.push(currentDate.format(dateFormat));
            }
            currentDate.add(1, 'day');
        }
        setRepeatDates(dates);
    };

    const handlePriceChange = (e) => {
        const value = e.target.value;
        if (!isNaN(value) && value !== '') {
            const formattedValue = parseFloat(value).toFixed(2);
            setPrice(formattedValue);
        } else {
            setPrice(value);
        }
    }
    const providedDayDateSetup = (startDateStr, endDateStr, day) => {
        const dates = [];
        let currentDate = moment(startDate, dateFormat);
        const lastDate = moment(endDate, dateFormat);
        while (currentDate.isSameOrBefore(lastDate)) {
            let dateDay = currentDate.format('dddd')
            console.log('day', dateDay)
            if (dateDay === day) {
                dates.push(currentDate.format(dateFormat));
            }
            currentDate.add(1, 'day');
        }
        setRepeatDates(dates);
    };

    console.log(repeatDates, 'repeatDates==>')

    const onChangeRepeatType = (v) => {
        setRepeatType(v)
        if (v === 'daily') {
            dailyDateSetup(startDate, endDate)
        } if (v === 'custom') {
            dateSetupForCustom(startDate, endDate)
        } else if (v === '5day') {
            workingDayDateSetup(startDate, endDate)
        }
    }

    const onChangeWeeklyDay = (v) => {
        setWeeklyDay(v)
        providedDayDateSetup(startDate, endDate, v)
    }

    const onFinish = async (values) => {
        user?.userType === 'clanic' && (values.clanicId = user?._id)
        values.time = (values?.time).format('HH:mm')
        setLoading(true)
        if (edit?._id) {
            values._id = edit?._id
            axios.post(POST.EDIT_SERVICE_FROM, values)
                .then(async (res) => {
                    const { data } = res
                    setLoading(false)
                    if (data?.success) {
                        await clanicData.getMyAllServices(userActions, user?._id)
                        await onCancel()
                        return successMessage(data?.message)
                    }
                    errorMessage(data?.message)
                })
                .catch((e) => {
                    setLoading(false)
                    errorMessage(e?.message)
                })
        } else {
            axios.post(POST.ADD_SERVICE_FROM, values)
                .then(async (res) => {
                    const { data } = res
                    setLoading(false)
                    if (data?.success) {
                        await clanicData.getMyAllServices(userActions, user?._id)
                        return successMessage(data?.message)
                    }
                    errorMessage(data?.message)
                })
                .catch((e) => {
                    setLoading(false)
                    errorMessage(e?.message)
                })
        }
    }
    return (
        <div>
            <Form
                initialValues={{ price: price }}
                name='form'
                onFinish={onFinish}
                layout={'vertical'}
                form={form}
            >
                <div className='form-two-input-flex'>
                    <div className='form-two-input-flex-inner-input'>
                        <Form.Item
                            name={"serviceName"}
                            label={selectedLanguage?.txt_service_name}
                            initialValue={edit?.serviceName}
                        >
                            <Input
                                className='form-input-new-style' placeholder={selectedLanguage?.txt_service_name} />
                        </Form.Item>
                    </div>
                    <div className='form-two-input-flex-inner-input'>
                        <Form.Item
                            name="price"
                            label={selectedLanguage?.txt_price}
                            initialValue={edit?.price}
                        >
                            <Input
                                defaultValue={edit?.price}
                                type="text"
                                onChange={handlePriceChange}
                                className='form-input-new-style'
                                placeholder={selectedLanguage?.txt_price}
                            />
                        </Form.Item>
                    </div>
                </div>
                <div className='form-two-input-flex'>
                    <div className='form-two-input-flex-inner-input' >
                        <Form.Item
                            name='subServices'
                            hasFeedback
                            label={<p className='new-pp-colr-wht'>{selectedLanguage?.txt_select_sub_services}</p>}
                            initialValue={edit?.subServices?.map((v, i) => v?._id)}
                        >
                            <Select
                                mode='multiple'
                                allowClear
                                className='form-input-new-style'
                                placeholder={selectedLanguage?.txt_select_sub_services}
                            >{(myServicesData || [])?.map((v, i) => {
                                return (
                                    <Option value={v?._id}>{v?.serviceName}</Option>
                                )
                            })}
                            </Select>
                        </Form.Item>
                    </div>
                    <div className='form-two-input-flex-inner-input'>
                        <Form.Item
                            label={selectedLanguage?.txt_time}
                            name={'time'}
                            rules={[
                                {
                                    required: true,
                                    message: selectedLanguage?.txt_please_select_day_time_setting
                                }
                            ]}
                            initialValue={strToMoment(edit?.time, 'HH:mm')}
                        >
                            <TimePicker
                                style={{ width: '100%' }}
                                className='form-input-new-style'
                                placeholder={selectedLanguage?.txt_enter_time_here}
                                format='HH:mm'
                            />
                        </Form.Item>
                    </div>
                </div>
                <div className='form-two-input-flex'>
                    <div className='form-two-input-flex-inner-input '>
                        <Form.Item
                            label={<p className='new-pp-colr-wht' style={{ marginTop: 10 }}>{' '}</p>}
                            name='repeat'
                            initialValue={repeat}
                            onChange={(e) => setRepeat(e.target.checked)}
                            valuePropName='checked'>
                            <Checkbox className='caheck-box-h'>{selectedLanguage?.txt_repeat}</Checkbox>
                        </Form.Item>
                    </div>
                    {repeat &&
                        <div className='form-two-input-flex-inner-input'>
                            <Form.Item
                                name='repeatType'
                                hasFeedback
                                label={<p className='new-pp-colr-wht'>{selectedLanguage?.txt_select_repeat_type}</p>}
                                rules={[
                                    {
                                        required: true,
                                        message: selectedLanguage?.txt_please_select_repeat_type
                                    }
                                ]}
                                initialValue={repeatType}
                            >
                                <Select
                                    disabled={edit?._id}
                                    showArrow
                                    allowClear
                                    className='form-input-new-style'
                                    onChange={onChangeRepeatType}
                                    placeholder={'Select Repeat Type'}
                                >
                                    <Option value={'daily'}>{selectedLanguage?.txt_daily}</Option>
                                    <Option value={'weekly'}>{selectedLanguage?.txt_weekly}</Option>
                                    <Option value={'monthly'}>{selectedLanguage?.txt_monthly}</Option>
                                    <Option value={'custom'}>{selectedLanguage?.txt_custom}</Option>
                                </Select>
                            </Form.Item>
                        </div>}
                </div>
                <div className='form-two-input-flex'>
                    {(repeat && repeatType === 'weekly')
                        &&
                        <div className='form-two-input-flex-inner-input' style={{ width: '100%' }}>
                            <Form.Item
                                name='weeklyDay'
                                hasFeedback
                                label={<p className='new-pp-colr-wht'>{selectedLanguage?.txt_select_day}</p>}
                                rules={[
                                    {
                                        required: true,
                                        message: selectedLanguage?.txt_please_select_day
                                    }
                                ]}
                            >
                                <Select
                                    disabled={edit?._id}
                                    showArrow
                                    allowClear
                                    className='form-input-new-style'
                                    placeholder={selectedLanguage?.txt_please_select_day}
                                    initialValue={weeklyDay}
                                    onChange={onChangeWeeklyDay}
                                >
                                    {['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']?.map((v, i) => {
                                        return (
                                            <Option value={v} key={i}>{v}</Option>
                                        )
                                    })}
                                </Select>
                            </Form.Item>
                        </div>
                    }
                    {(repeat && repeatType === 'custom')
                        &&
                        <div className='form-two-input-flex-inner-input' style={{ width: '100%' }}>
                            <Form.Item
                                name='customsDay'
                                label={<p className='new-pp-colr-wht'>{selectedLanguage?.txt_select_customs_dates}</p>}
                                rules={[
                                    {
                                        required: !true,
                                        message: selectedLanguage?.txt_please_select_customs_dates,
                                    },
                                ]}
                            >
                                <Select
                                    disabled={edit?._id}
                                    mode='multiple'
                                    showArrow
                                    allowClear
                                    onChange={onChangeCustomsDate}
                                    className='form-input-new-style-select-minhi'
                                    placeholder={selectedLanguage?.txt_please_select_customs_dates}
                                >
                                    {valuesForCustomDate?.map((v, i) => {
                                        return (
                                            <Option value={v} key={i}>{`${v} - ${getDayOfWeak(v)} `}</Option>
                                        )
                                    })}
                                </Select>
                            </Form.Item>
                        </div>
                    }
                </div>
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                    {edit?._id &&
                        <Button
                            style={{ width: '120px', height: '40px' }}
                            type='primary'
                            onClick={onCancel}
                        >
                            {selectedLanguage?.txt_cancel}
                        </Button>}
                    <br />
                    <br />
                    <Form.Item>
                        <Button
                            style={{ width: '120px', height: '40px' }}
                            type='primary'
                            htmlType='submit'
                            laoding={laoding}
                        >
                            {edit?._id ? selectedLanguage?.txt_update : selectedLanguage?.txt_add}
                        </Button>
                    </Form.Item>
                </div>
            </Form >
        </div>
    )
}

export default ServiceFormComponent